import { FC, PropsWithChildren, useEffect, useRef } from 'react'

import { useGameEvents } from 'features/firebase/use-game-events'
import { useGameContext } from 'features/game/game-context'

import { useBoolean } from 'shared/hooks/use-boolean'

export const AI_1 = 'Tom'

export const AIAgent: FC<PropsWithChildren> = ({ children }) => {
  const {
    game: { ai, status },
    boardState,
  } = useGameContext()
  const { dispatchRawEvent } = useGameEvents()
  const [aiEnabled, toggleAiEnabled] = useBoolean(false)
  const workerRef = useRef<Worker | null>(null)
  const dispatchRef = useRef(dispatchRawEvent)

  useEffect(() => {
    if (!workerRef.current) {
      workerRef.current = new Worker(new URL('./ai.worker.ts', import.meta.url))
    }

    const worker = workerRef.current

    worker.onmessage = event => {
      const nextBestMove = event.data
      if (nextBestMove) {
        dispatchRef.current(nextBestMove)
      }
    }

    return () => {
      worker.terminate()
      workerRef.current = null
    }
  }, [])

  useEffect(() => {
    setTimeout(() => toggleAiEnabled(true), 2000)
  }, [toggleAiEnabled])

  useEffect(() => {
    dispatchRef.current = dispatchRawEvent
  }, [dispatchRawEvent])

  useEffect(() => {
    if (aiEnabled && workerRef.current && status === 'playing' && boardState.turn === ai) {
      workerRef.current.postMessage({
        boardState,
        playsAs: ai,
      })
    }
  }, [aiEnabled, status, ai, boardState])

  return <>{children}</>
}
